export default [
  {
    title: '计划组/计划/创意名称',
    key: 'bizName',
    width: 180
  },
  {
    title: '层级',
    key: 'bizType',
    width: 68
  },
  {
    title: '媒体名称',
    key: 'mediaName',
    width: 92
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: 120
  },
  {
    title: '任务类型',
    key: 'ruleType',
    width: 90
  },
  {
    title: '任务/规则ID',
    key: 'ruleId',
    align: 'center'
  },
  {
    title: '执行前',
    key: 'oldValue',
    width: 120,
    overflow: true
  },
  {
    title: '执行后',
    key: 'newValue',
    width: 120,
    overflow: true
  },
  {
    title: '操作类型',
    key: 'opType',
    width: 74
  },
  {
    title: '数据快照',
    key: 'snapshotDetail',
    width: 200,
    overflow: true
  },
  {
    title: '计划新建人',
    key: 'launchOpName'
  },
  {
    title: '执行人',
    key: 'opName'
  },
  {
    title: '执行状态',
    key: 'opStatus',
    width: 162,
    overflow: true
  },
  {
    title: '执行时间',
    key: 'createTime',
    width: 120
  }
]
